// @generated da scripts/i18n-sr-cyrl.mjs — NON EDITARE A MANO.
// i18n area 'backups' — locale sr-Cyrl-RS: TRASLITTERAZIONE MECCANICA
// di backups.sr-Latn-RS.ts (srpska latinica). Ogni modifica va fatta
// sulla locale sr-Latn-RS e poi rigenerata con: node scripts/i18n-sr-cyrl.mjs
// Sidecar anti-stantie: ../meta/backups.sr-Cyrl-RS.meta.json.
import type { enUS } from './backups'

export const srCyrlRS: typeof enUS = {
  ckpt: {
    contents: 'Прима',
    contentsHint:
      'Шта овде сме да слети. „Checkpoints“ је конфигурација кластера, „Резервне копије података“ су копије VM: два читања се састављају, једно одредиште може примити оба.',
    content: { checkpoints: 'Checkpoints', backups: 'Резервне копије података' },
    destinationsTitle: 'Одредишта бекапа',
    checkpointsTitle: 'Checkpointi',
    restoreTitle: 'Враћање',
    addDestination: 'Додај одредиште',
    addDestinationTitle: 'Додајте одредиште бекапа',
    editDestinationTitle: 'Измените одредиште',
    storage: 'Storage',
    storageHint: 'Dir-like storage (dir/NFS/CIFS/CephFS) — артефакти су обичне датотеке под namespaceom платформе.',
    schedule: 'Распоред',
    scheduleNone: 'Само ручно',
    scheduleHourly: 'Сваког сата',
    scheduleDaily: 'Дневно',
    scheduleWeekly: 'Недељно',
    scheduleHour: 'Сат',
    scheduleWeekday: 'Дан',
    scheduleHint:
      'Планирани checkpointi немају оператера који укуцава masterpass: тајне из keystorea пакују се као плацехолдери.',
    retention: 'Retention',
    retentionHint:
      'Колико планираних checkpointa задржати — sweeper уклања најстарије преко тог броја. Ручни checkpointi и checkpointi пре враћања никада се не уклањају.',
    paused: 'Паузирано',
    pausedHint:
      'Оператерово замрачење: док пауза траје, на овом одредишту ништа се не планира и ништа се не орезује — policy за податке и checkpointi подједнако. Извршавања у току никада се не дирају.',
    orphanRuns: '{n} осиротелих извршавања',
    orphanRunsHint:
      'Планирана извршавања policy које више не постоје на овом одредишту: никаква retention их не управља — никад бројана, никад орезивана — и брише их само рука. Сочиво „backups“ у tvirt диагносе именује уклоњене policy.',
    rescan: 'Поново усвоји артефакте',
    rescanTitle: 'Поновно усвајање артефаката за {name}',
    rescanHint:
      'Поново гради каталог резервних копија (VM/CT/App) из manifesta артефаката на одредишту. Постојећи редови се никад не дирају; копије непознатих политика остају сирочићи (никад се аутоматски не орезују). Потез после bootstrap обнове.',
    masterpassDrWarning:
      'Сценарио катастрофе: LUKS дискови се враћају САМО из checkpointa SA masterpass-om. Планирани checkpointi пакују чуваре места — повремено направите ручни checkpoint са masterpass-om.',
    policy: {
      title: 'Policy резервних копија података',
      hint: 'Именоване policy: који објекти (kind, тагови, scopeovi), колико често, када извршавање сме да крене и колико копија задржати. Гест уписа остаје власнику објекта: тагови се додељују на његовом сопственом scopeu.',
      add: 'Додај policy',
      column: 'Policy података',
      name: 'Назив',
      nameHint:
        'Ознака policy, јединствена унутар одредишта. Извршавања прате стабилни ид policy: преименовање је бесплатно; брисање чини њена извршавања сирочићима (више се не броје нити орезују).',
      kindLocked: 'Породица објеката постојеће policy не може се променити: направите нову policy.',
      kindLabel: 'Објекти',
      kind: { vm: 'Виртуелне машине', ct: 'Контејнери', app: 'Апликације' },
      tags: 'Селектор тагова',
      tagsHint:
        'Парови таг=вредност одвојени запетама, у AND-у. Празни тагови и scopeovi не бирају ништа — никада „све“.',
      scopes: 'Scopeovi',
      scopesHint: 'Путање scopeova (подстабла), одвојене запетама, међусобно у OR-у.',
      windowStart: 'Прозор од',
      windowEnd: 'Прозор до',
      windowHint:
        'Прозор извршавања (HH:MM, локално време; почетак иза краја прескаче поноћ). Управља само POČETKOM: извршавање које га прекорачи никада се не убија.',
      mode: 'Режим',
      modeHint: 'Инкрементални јаше на породици серија; прекинута серија деградира у full, речено у дневнику.',
      modeFull: 'Full',
      modeIncremental: 'Инкрементални',
      requireQuiesce: 'Захтевај quiesce (guest агент)',
      paused: 'Policy паузирана',
      retentionNone: 'Задржи све',
      retentionCount: 'Број',
      retentionGfs: 'GFS прстенови',
      gfs: { keepLast: 'Последње', daily: 'Дневне', weekly: 'Недељне', monthly: 'Месечне', yearly: 'Годишње' },
      gfsHint:
        'За сваки прстен задржава се најновија копија из сваког од последњих N периода. Задржана копија држи у животу цео свој ланац — никада база са сирочићима.',
      lastRun: 'Последње извршавање',
      neverRan: 'никада извршено'
    },
    lastCheckpoint: 'Последњи checkpoint',
    neverRun: 'Никада креирано',
    createNow: 'Креирај checkpoint',
    createNowTitle: 'Креирајте checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Штити тајне вредности у keystoreu (argon2id → AES-256-GCM, по вредности). Никада се не чува: сачувајте га — без њега враћање даје плацехолдере уместо правих тајни.',
    masterpassEmptyHint: 'Оставите празно да се уместо тајни упакују експлицитни плацехолдери.',
    createStarted: 'Checkpoint у току…',
    destinationInUseError: "'{name}' још садржи checkpointe — прво их обришите.",
    origin: 'Порекло',
    originManual: 'ручно',
    originSchedule: 'планирано',
    originPreRestore: 'пре враћања',
    originPreChange: 'пре измене',
    preChangeRetention: 'Checkpointi пре измене',
    preChangeRetentionHint:
      'Празно = искључено. Први упис конфигурације после периода мировања овде замрзава претходно стање (порекло „пре измене“); најновији се чувају до броја — сопствена ретенција, подложна орезивању.',
    diffTitle: 'Преглед измена',
    diffFailed: 'Преглед није успео',
    diffRetry: 'Покушај поново',
    diffCounts: '{changed} за измену · {missing} за креирање · {extra} вишка · {equal} идентично',
    diffChanged: 'мења се',
    diffMissing: 'био би креиран',
    diffExtra: 'био би обрисан',
    diffJsonb: 'јсонб референце није могуће проверити пре примене',
    diffSecret: 'запечаћена поља, неупоредива',
    diffMore: 'још {n}…',
    diffNeeded: 'Покретање се активира кад преглед одражава избор.',
    phase: 'Стање',
    phaseRunning: 'у току',
    phaseComplete: 'завршено',
    phaseError: 'грешка',
    secrets: 'Тајне',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'плацехолдери',
    size: 'Величина',
    created: 'Креирано',
    destination: 'Одредиште',
    download: 'Преузми .tvbk',
    deleteCheckpoint: 'Обриши checkpoint',
    noCheckpoints: 'Још нема checkpointa — креирајте један са неког одредишта.',

    // Round #156 (dialog standard): la superficie di lettura completa del
    // record di archivio — righe di dettaglio per i campi mai mostrati in tabella.
    families: 'Фамилије',
    generation: 'Генерација',
    completedAt: 'Завршено',
    errorDetail: 'Детаљ грешке',
    manifest: 'Manifest',
    restoreHint: 'Отпремите .tvbk артефакт: explorer приказује шта он носи, а затим бирате шта вратити и како.',
    uploadFile: 'Отпреми .tvbk датотеку',
    uploading: 'Отпремање…',
    uploadFailed: 'Артефакт није могуће отворити',
    explorerTitle: 'Садржај checkpointa',
    checkpointFrom: 'Checkpoint кластера {cluster}, креиран {when} ({origin}, генерација {generation})',
    otherCluster:
      'Овај checkpoint потиче са ДРУГОГ кластера ({cluster}) — cross-cluster враћање стиже у будућој рунди.',
    encrypted: 'шифровано',
    objectsCount: 'објеката: {n}',
    mode: 'Режим',
    modeMerge: 'Merge — усклађује: upsert изабраних, ништа не брише',
    modeOverwrite:
      'Overwrite — checkpoint побеђује: фамилија изабрана у целини замењује се цела (постојећи редови којих нема у checkpointu нестају)',
    restoreMasterpassHint:
      'Masterpass са којим је checkpoint креиран. Без њега се шифроване тајне враћају као експлицитни плацехолдери.',
    checkMasterpass: 'Провери',
    masterpassOk: 'Masterpass исправан',
    masterpassWrong: 'Погрешан masterpass',
    parachuteDestination: 'Падобранско одредиште',
    parachuteHint: 'Пре него што додирне иједан ред, задатак овде креира аутоматски checkpoint пре враћања.',
    summaryTitle: 'Шта ће се десити',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'цела фамилија',
    summaryObjects: 'изабраних објеката: {n}',
    confirmHint: 'Укуцајте име кластера ({name}) да потврдите — враћање преписује декларисану конфигурацију.',
    confirmField: 'Име кластера',
    startRestore: 'Врати',
    restoreRunning: 'Враћање у току…',
    restoreDone: 'Враћање завршено — рецонцилери конвергирају ка новој декларацији.',
    restoreFailed: 'Враћање није успело',
    discard: 'Одбаци',
    selectionEmpty: 'Изаберите бар једну фамилију или један објекат.'
  },

  backup: {
    intro: {
      title: 'Резервне копије података VM-ова и контејнера',
      subtitle: 'Градивни блокови којима се служи спољни софтвер за резервне копије',
      whatItIs:
        'TVirt излаже четири примитиве: quiesced снимке, праћење промена по диску, NBD експорт само за читање и експорт конфигурације. Њима управљају Veeam, Bacula, Acronis и друштво.',
      whatItIsNot:
        'TVirt није производ за резервне копије: ништа не планира, не примењује ретенцију и не чува никакву архиву ваших података. Ретенција, каталози и политике враћања остају на софтверу који већ користите.'
    },
    cbt: {
      title: 'Праћење промена',
      colVm: 'VM',
      colDisk: 'Диск',
      colState: 'Стање',
      colBitmaps: 'Битмапе',
      colObservedAt: 'Забележено',
      colChangeId: 'Цханге ID',
      colMechanic: 'Механизам',
      stateActive: 'Активно',
      stateInactive: 'Искључено',
      stateInconsistent: 'Недоследно — следећа резервна копија мора бити пуна',
      stateBroken: 'Ланац прекинут — искључите, па укључите као нови ланац',
      stateSnapshots: 'Увек укључено — делта између снимака',
      stateUnavailable: 'Недоступно на овом диску',
      mechanic: {
        'qcow2-bitmap': 'qcow2 битмапа',
        'rbd-snapdiff': 'Дифф Ceph снимака',
        'lvm-thin-delta': 'Делта thin poola',
        none: 'Нема'
      },
      empty:
        'Нема VM диска. Праћење промена чита се по диску: укључите га на qcow2 диску или правите снимке на rbd/SAN.',
      chainBroken: 'Ланац прекинут',
      chainBrokenText:
        'Прекинут догађајем {reason}: {bitmaps}. Искључите битмапу (ланац је изгубљен, следећа копија је пуна), па је укључите као нови ланац.',
      lineages: 'Епохе',
      epochFrozen: 'замрзнута у снимку {snapshot}',
      epochLost: 'изгубљена ({cause})',
      epochRecording: 'бележи на глави',
      milestones: 'Прекретнице (снимци)',
      enable: 'Укључи праћење промена',
      disable: 'Искључи',
      reset: 'Ресетуј',
      changedAreas: 'Промењене области',
      denied: 'Немате дозволу на овој VM',
      enableTitle: 'Укључи праћење промена',
      disableTitle: 'Искључи праћење промена',
      resetTitle: 'Ресетуј битмапу',
      areasTitle: 'Промењене области',
      bitmapName: 'Назив битмапе',
      bitmapNameHint: 'Сопствени назив: tvirt- и tvbk- припадају платформи',
      granularity: 'Грануларност (бајтови)',
      granularityHint: 'Степен двојке; подразумевано 65536',
      bitmap: 'Битмапа',
      disableHint: 'Уклања битмапу и целу историју њених епоха: следећа копија мора бити пуна.',
      resetHint: 'Празни битмапу — нова основа: цханге ID старији од reseta више се не може сложити.',
      areasFrom: 'Од снимка',
      areasTo: 'До снимка',
      areasRun: 'Израчунај',
      areasResult: '{count} промењених области, {bytes}',
      areasEmpty: 'Нема промењених области између два снимка',
      areasZero: 'нуле',
      areasMore: 'приказано првих {shown} од {count}',
      submit: 'Потврди',
      error: 'Радња праћења промена није успела'
    },
    exports: {
      title: 'Отворени NBD експорти',
      colVm: 'VM',
      colDisk: 'Диск',
      colSnapshot: 'Снимак',
      colBitmap: 'Битмапа',
      colPhase: 'Фаза',
      colNode: 'Чвор',
      colEndpoint: 'Endpoint',
      colExpires: 'Истиче',
      colCreated: 'Отворено',
      colError: 'Грешка',
      phase: {
        preparing: 'Припрема',
        ready: 'Спреман',
        closed: 'Затворен',
        error: 'Неуспео'
      },
      expiresIn: 'за {minutes} min',
      expired: 'истекао',
      empty: 'Нема exporta. Сесија читања служи један диск на једном снапсхоту NBD клијенту; сесија писања пуни нетакнут диск заустављене VM. Обе умиру по истеку.',
      endpointHint: 'TLS са CA кластера; назив експорта је улазница — умире са сесијом',
      closeDenied: 'Немате дозволу да затварате експорте ове VM',
      open: 'Отвори NBD експорт',
      openTitle: 'Отвори NBD експорт',
      openDisk: 'Диск',
      openBitmap: 'Битмапа (опционо)',
      openBitmapHint:
        'Објављује епоху те битмапе замрзнуту у овом снимку као meta-context промењених екстената (само qcow2 дискови)',
      openTtl: 'Трајање (минути)',
      openSubmit: 'Отвори',
      openError: 'Експорт није могао да се отвори',
      colMode: 'Режим',
      mode: {
        read: 'Читање',
        write: 'Писање'
      },
      caCertificate: 'CA кластера',
      caCopy: 'Копирај PEM',
      caDownload: 'Преузми ца-церт.пем',
      caHint: 'Запишите PEM у ца-церт.пем у приватном директоријуму и повежите се са нбдс://…?тлс-certificates=<direktorijum> (nbdcopy, нбдинфо) или --object тлс-цредс-x509,dir=<direktorijum>,endpoint=client (qemu-img)',
      caAbsent: 'Сесија не носи CA (нема PKI)',
      openWrite: 'Отвори export за писање',
      openWriteTitle: 'Отвори export за писање',
      openWriteIntro: 'Диск мора бити нетакнут: рођен празан, никад писан, без снапсхота; VM заустављена. Враћање PUNI диск, не поправља га. Док је сесија отворена, VM се не покреће, не прави снапсхот, не клонира се, а диск се не премешта.',
      openWriteSubmit: 'Отвори',
      openWriteError: 'Export за писање није могао да се отвори',
      openWriteDenied: 'Недостаје вам vm.restore.data на овој VM',
      openWriteStopped: 'Зауставите VM да бисте отворили export за писање',
      fromDescription: 'Направи VM из описа',
      fromDescriptionTitle: 'Направи VM из описа',
      fromDescriptionIntro: 'Опис из export-vm-meta враћа се као заустављена VM са празним дисковима описане геометрије — спремна за exporte за писање, диск по диск. Бајтови не пролазе овуда: носи их ресторе-диск (CLI) или NBD клијент производа за резервне копије.',
      fromDescriptionDoc: 'Опис (JSON)',
      fromDescriptionDocHint: 'Налепите документ из export-vm-meta или изаберите датотеку',
      fromDescriptionFile: 'Изабери датотеку…',
      fromDescriptionInvalid: 'Текст није JSON документ',
      fromDescriptionName: 'Име нове VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Ваш почетни scope',
      fromDescriptionStorage: 'Складиште дискова',
      fromDescriptionStorageHint: 'Сваки диск се рађа овде, у подразумеваном формату складишта',
      fromDescriptionMetadataStorage: 'Складиште метаподатака',
      fromDescriptionSameAsStorage: 'Исто као за дискове',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Без бриџа ни мреже VM се рађа без картица',
      fromDescriptionNetwork: 'Логичка мрежа (fabric/мрежа)',
      fromDescriptionSubmit: 'Направи',
      fromDescriptionError: 'VM није могла да се направи',
      fromDescriptionDone: 'VM направљена: {name}',
      fromDescriptionOpen: 'Отвори VM',
      fromDescriptionDenied: 'Недостаје вам вм.цреате',
      fromDescriptionStillRunning: 'Прављење још траје: чека се даље'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Резервне копије података VM',
      titleOnVm: 'Резервне копије података',
      empty:
        'Нема копије. Копија преноси дискове, varstore UEFI и стање vTPM на одредиште и надживљава виртуелну машину.',
      colVm: 'VM',
      colCreated: 'Направљена',
      colPhase: 'Исход',
      colDestination: 'Одредиште',
      colContains: 'Садржај',
      colSize: 'Величина',
      colOrigin: 'Порекло',
      colMode: 'Врста',
      retentionChip: 'Задржавање',
      retentionHint:
        'Задржавање одредишта може обрисати ову копију не питајући: рођена је из распореда. Ручне копије се никада не помету.',
      policyRemoved: 'Policy уклоњена: {name}',
      policyRemovedHint:
        'Policy која је планирала овај backup више не постоји: никаква retention га не управља (никад се не орезује аутоматски) — обришите га ручно кад више не треба.',
      phase: {
        running: 'У току',
        complete: 'Завршена',
        error: 'Неуспела'
      },
      origin: {
        manual: 'Ручна',
        schedule: 'Заказана'
      },
      mode: {
        full: 'Пуна',
        incremental: 'Инкрементална'
      },
      contains: {
        disks: 'Дискови',
        varstore: 'Varstore UEFI',
        vtpm: 'Стање vTPM',
        snapshots: 'Снимци'
      },
      vmState: {
        stopped: 'VM угашена',
        running: 'VM ради (топло)'
      },
      artifactClass: { metadata: 'Метаподаци', data: 'Подаци', secret: 'Тајна' },
      detail: {
        tabOverview: 'Преглед',
        tabArtefact: 'Артефакт',
        id: 'Идентификатор',
        scope: 'Опсег',
        vmState: 'Стање VM при копирању',
        pointInTime: 'Тренутак података',
        completedAt: 'Завршена',
        node: 'Чвор који је копирао',
        error: 'Грешка',
        path: 'Фасцикла на складишту',
        checksum: 'sha256 manifesta',
        secretsExposed: 'Осетљив материјал у отвореном облику',
        secretsExposedYes: 'Да — одредиште не шифрује',
        secretsExposedNo: 'Не',
        baseBackup: 'Основна копија',
        tabManifest: 'Manifest',
        manifestHint:
          'Отворени индекс артефакта: један фајл по реду са својим sha256. Фасцикла се проверава и без TVirt-а — довољни су qemu-img, tar и jq.',
        manifestEmpty: 'Manifest не наводи фајлове.',
        manifestError: 'Manifest се не може прочитати',
        colEntry: 'Фајл',
        colClass: 'Класа',
        colSha: 'sha256'
      },
      create: {
        action: 'Копирај сада',
        title: 'Копирај сада',
        submit: 'Покрени копију',
        destination: 'Одредиште',
        destinationHint: 'Само одредишта која примају копије.',
        noDestinations: 'Ниједно одредиште не прима копије: направите га у Систем → Checkpoints.',
        contentsHint:
          'Путују сви дискови, varstore UEFI и стање vTPM. Последња два су суштина: запечаћен гост мора поново да се подигне.',
        error: 'Копија није кренула',
        stillRunning: 'Копија још траје — копирање се наставља и ако затворите.',
        vmRunning:
          'Машина је {phase}: резервна копија тражи стабилну VM — угашену за хладно копирање, покренуту за топло.'
      },
      restore: {
        action: 'Врати',
        title: 'Врати',
        intro: 'Враћање је неповратно. Изаберите где се подаци враћају: у нову машину или преко изворне.',
        modeNewVm: 'Врати у НОВУ VM',
        modeNewVmHint:
          'Не dira ништа што постоји — тиме се копија проверава. Нови идентификатор и свеже исковане MAC адресе.',
        modeOver: 'Пребриши изворну VM',
        modeOverHint: 'Уништава тренутне податке циљне VM, без повратка. Машина мора бити угашена.',
        newName: 'Име нове VM',
        newNameHint: 'Мора бити слободно у циљном опсегу.',
        storage: 'Складиште за дискове',
        storageHint: 'Обавезно: manifest бележи величину и формат диска, никада складиште на ком је лежао.',
        metadataStorage: 'Складиште за varstore и vTPM',
        metadataStorageHint: 'Где слећу UEFI идентитет и стање vTPM.',
        sameAsStorage: 'Исто као дискови',
        bridge: 'Bridge домаћина',
        bridgeHint:
          'Свака забележена мрежна картица враћа се на овај bridge са новом MAC адресом. Остављено празно, VM се рађа без картица — сигурнија подразумевана вредност.',
        overwriteTitle: 'Управо ћете пребрисати ову VM',
        overwriteName: 'Име',
        overwriteId: 'Идентификатор',
        overwriteDisks: 'Дискови који ће бити пребрисани',
        overwriteNoDisks: 'Нема дискова.',
        overwriteKeeps:
          'Нетакнути остају идентификатор, име, опсег, мрежне картице и MAC адресе: копија су PODACI, конфигурација је checkpoint.',
        confirmField: 'Име VM',
        confirmHint: 'Укуцајте {name} за потврду.',
        targetLoading: 'Читање циљне VM…',
        targetRunning: 'Циљна VM је {phase}: враћање пребрисује бајтове испод госта, па је тражи угашену.',
        targetGone: 'Изворна VM се више не може прочитати: остаје враћање у нову VM.',
        onlyComplete: 'Копија је {phase}: вратити може само завршена копија.',
        submitNewVm: 'Врати у нову VM',
        submitOver: 'Пребриши',
        error: 'Враћање није кренуло',
        stillRunning: 'Враћање још траје — копирање целих дискова тражи време.'
      }
    },
    guest: {
      title: {
        ct: 'Резервне копије података контејнера',
        app: 'Резервне копије података App-ова'
      },
      tabTitle: 'Резервне копије',
      empty: 'Нема копија. Копија преноси трајне податке на одредиште и надживљава свој објекат.',
      colSubject: {
        ct: 'Контејнер',
        app: 'App'
      },
      colCreated: 'Направљена',
      colPhase: 'Исход',
      colDestination: 'Одредиште',
      colContains: 'Садржај',
      colSize: 'Величина',
      colOrigin: 'Порекло',
      policyRemoved: 'Policy уклоњена: {name}',
      policyRemovedHint:
        'Policy која је планирала овај backup више не постоји: никаква retention га не управља (никад се не орезује аутоматски) — обришите га ручно кад више не треба.',
      phase: {
        running: 'У току',
        complete: 'Завршена',
        error: 'Неуспела'
      },
      origin: {
        manual: 'Ручна',
        schedule: 'Планирана'
      },
      state: {
        stopped: 'Објекат заустављен',
        running: 'Објекат ради (замрзнут)'
      },
      contains: {
        rootfs: 'Стабло rootfs',
        config: 'Конфигурација',
        volumes: 'Трајни волумени',
        root: 'Трајни root'
      },
      artifactClass: {
        metadata: 'Метаподаци',
        data: 'Подаци',
        secret: 'Тајна'
      },
      create: {
        action: 'Направи копију сада',
        title: 'Нова резервна копија',
        submit: 'Покрени копију',
        error: 'Копија није кренула',
        destination: 'Одредиште',
        destinationHint: 'Само одредишта која прихватају резервне копије података.',
        noDestinations:
          'Ниједно одредиште не прихвата резервне копије података: додајте одредишту „Резервне копије података“.',
        hint: {
          ct: 'Путује цело стабло rootfs, верно (нумерички власници, xattr, ACL), плус декларисана конфигурација у manifestu. Контејнер који ради се ZAMRZAVA за цело паковање: crash-consistent копија, декларисана.',
          app: 'Путују САМО трајни волумени (и трајни root), плус конфигурација у manifestu. Ефемерно је искључено ратификацијом и manifest га именује; енв вредности декларисане тајнима не путују.'
        },
        stillRunning: 'Копија још траје — паковање целих стабала траје.'
      },
      detail: {
        tabOverview: 'Преглед',
        tabManifest: 'Manifest',
        id: 'Идентификатор',
        scope: 'Опсег',
        state: 'Стање при копији',
        pointInTime: 'Подаци у тренутку',
        completedAt: 'Закључена',
        node: 'Чвор који је копирао',
        error: 'Грешка',
        path: 'Фасцикла на складишту',
        checksum: 'sha256 manifesta',
        manifestHint:
          'Индекс артефакта: један запис по датотеци са својим sha256 — без хешева је „копија постоји“ чин вере.',
        manifestError: 'Manifest се не може прочитати',
        manifestEmpty: 'Нема артефаката у manifestu.',
        colEntry: 'Датотека',
        colClass: 'Класа',
        colSha: 'sha256',
        excluded: 'Искључено ратификацијом (не путује)',
        secretKeys: 'Изостављени тајни енв кључеви (#307) — поново их унесите после враћања'
      },
      restore: {
        action: 'Врати',
        title: 'Враћање',
        submit: 'Врати',
        error: 'Враћање није кренуло',
        stillRunning: 'Враћање још траје — распакивање целих стабала траје.',
        onlyComplete: 'Копија је {phase}: вратити може само завршена копија.',
        asNew: {
          ct: 'У НОВИ контејнер — ништа не уништава: гест којим се копија проверава',
          app: 'У НОВИ App — ништа не уништава: гест којим се копија проверава'
        },
        over: {
          ct: 'PREKO изворног контејнера — цело стабло rootfs се замењује',
          app: 'PREKO изворног App-a — садржај сваког трајног волумена се замењује'
        },
        name: 'Назив новог објекта',
        storage: 'Складиште',
        storageHint: 'Где враћени подаци слећу — manifest никад не бележи изгубљени pool.',
        storageDeclared: 'Складишта декларисана у manifestu',
        bridge: 'Мост домаћина',
        bridgeHint:
          'Свака забележена картица враћа се на овај мост са свежим MAC-ом. Празно = рађа се неповезан, најсигурније подразумевано.',
        node: 'Чвор',
        nodeHint: 'Члан на коме се App поново рађа: чвор је идентитет кластера и никад не долази из manifesta.',
        secretKeysWarning:
          'Енв вредности декларисане тајнима не путују у копији: поново рођена копија их жели унете (log задатка именује кључеве).',
        overInventory: 'Управо ћете преписати овај објекат',
        confirmType: 'Упишите {name} за потврду',
        targetGone: 'Изворни објекат више се не може прочитати: остаје враћање као ново.',
        targetLoading: 'Читање циљног објекта…',
        targetRunning: 'Циљни објекат ради: враћање замењује бајтове под гостом па га жели заустављеног.'
      }
    }
  }
}
